import {
  Text,
  Wrap,
} from '@chakra-ui/react';
import {
  useCrashDistributionFreight,
} from '@src/modules/performance/context/reports-api-hooks';

import TornadoBarChart from '@src/modules/performance/components/charts/TornadoBarChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'DSI Distribution (ONF Freight)',
  content: [
    {
      title: 'Length vs no. deaths and serious injuries (ONF Freight)',
      description:
  <Text fontSize="inherit" mb={2}>
    The distributed network length of ONF Freight classes and the proportion of deaths and serious injuries (DSI) in those classes for the past ten financial years, in descending order of ONF Freight class. Road Efficiency Group Te Ringa Maimoa has calculated this result.
  </Text>,
      source: <Text fontSize="inherit" as="span">Sourced from the ONF classifications and crash information in AWM.</Text>,
    },
  ],
};
function RoadSafetyCrashDistributionFreight() {
  const { data: crashDistributionFreight, isLoading: isLoadingFreight } = useCrashDistributionFreight();
  const isLoading = isLoadingFreight;

  // Freight Crash Distribution Chart
  const crashDistributionFreightData = [
    {
      name: 'Length %',
      type: 'bar',
      data: crashDistributionFreight?.map((item) => ({
        x: item.category_desc,
        y: item.perc_total_length > 0.0015 ? item.perc_total_length * -100 : 0,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'DSI %',
      type: 'bar',
      data: crashDistributionFreight?.map((item) => ({
        x: item.category_desc,
        y: item.perc_total_dsi > 0.0015 ? item.perc_total_dsi * 100 : 0,
      })),
      color: CHART_COLOURS.red,
    },
  ];

  return (
    <ReportSection
      title="DSI Distribution (ONF Freight)"
      informationSource={informationSource}
      lockYear={crashDistributionFreight?.[0]?.LockYear}
      isLoading={isLoading || !crashDistributionFreight}
    >
      <Wrap>
        <TornadoBarChart
          title="Length vs no. deaths and serious injuries"
          categories={[...new Set(crashDistributionFreight?.map((item) => item.category_desc))]}
          series={crashDistributionFreightData}
          suffix="%"
          dataLabelFormatter={(val) => {
            if (val === 0) {
              return '';
            }
            const labelFormatted = val > 0 ? `${val.toFixed(0)}%` : `${Math.abs(val).toFixed(0)}%`;
            return labelFormatted;
          }}
        />
      </Wrap>
    </ReportSection>
  );
}

export default RoadSafetyCrashDistributionFreight;
